module.exports = __webpack_public_path__ + "img/uy.c1b448d3.svg";